module.exports = __webpack_public_path__ + "img/down.5c9aae8d.svg";